/**
 * Client entry point.
 *
 * The server sends a bare HTML shell (`index.html`) for every app route, and
 * this file boots the React SPA into it. TanStack Router (see `router.tsx`) owns
 * page routing, so navigation happens entirely client-side without full-page
 * reloads.
 */

import { ClerkProvider } from "@clerk/clerk-react";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { router } from "./router";

const elem = document.getElementById("root")!;

const BUN_PUBLIC_CLERK_PUBLISHABLE_KEY =
  process.env.BUN_PUBLIC_CLERK_PUBLISHABLE_KEY;

if (!BUN_PUBLIC_CLERK_PUBLISHABLE_KEY) {
  throw new Error("Add your Clerk Publishable Key to the .env file");
}

const app = (
  <StrictMode>
    <ClerkProvider publishableKey={BUN_PUBLIC_CLERK_PUBLISHABLE_KEY}>
      <RouterProvider router={router} />
    </ClerkProvider>
  </StrictMode>
);

// Bun requires HMR data to be accessed directly (without an intermediate
// variable). Reuse the root so a hot reload doesn't mount a second React tree.
const root = (import.meta.hot.data.root ??= createRoot(elem)) as ReturnType<
  typeof createRoot
>;
root.render(app);
